import {
  TUTORIAL_HOTSPOTS,
  TUTORIAL_IMAGE_REFS,
  type HotspotRect,
  type TutorialImageRef,
} from '../../constants/tutorialHotspots';
import burritoStep1 from '../../assets/imgs/newMenuTutorial/burrito_step_1_choose_protein.png';
import burritoStep2 from '../../assets/imgs/newMenuTutorial/burrito_step_2_choose_protein.png';
import burritoStep3 from '../../assets/imgs/newMenuTutorial/burrito_step_3_choose_protein.png';
import burritoStep4 from '../../assets/imgs/newMenuTutorial/burrito_step_4_choose_protein.png';
import tacoStep1 from '../../assets/imgs/newMenuTutorial/taco_step_1_pencil.png';
import tacoStep2 from '../../assets/imgs/newMenuTutorial/taco_step_2_pencil.png';
import tacoStep3 from '../../assets/imgs/newMenuTutorial/taco_step_3_pencil.png';

export type TutorialFrame = {
  image: string;
  highlight: HotspotRect;
  description: string;
  imageRef: TutorialImageRef;
};

export type TutorialSlide =
  | {
      id: string;
      type: 'splash';
      showSkip: false;
      title: null;
    }
  | {
      id: string;
      type: 'multiFrame';
      showSkip: true;
      title: string;
      badgeEmoji: string;
      bodyLead: string;
      bodyRest: string;
      frames: TutorialFrame[];
    }
  | {
      id: string;
      type: 'nameMapping';
      showSkip: true;
      title: string;
      bodyLead: null;
    };

export const NEW_MENU_TUTORIAL_SLIDES: TutorialSlide[] = [
  {
    id: 'splash',
    type: 'splash',
    showSkip: false,
    title: null,
  },
  {
    id: 'taco',
    type: 'multiFrame',
    showSkip: true,
    title: 'Taco Plates',
    badgeEmoji: '🌮',
    bodyLead: 'Now totally customizable',
    bodyRest: "Mix N' Match any of your favorite tacos!",
    frames: [
      {
        image: tacoStep1,
        imageRef: TUTORIAL_IMAGE_REFS.tacoStep1,
        highlight: TUTORIAL_HOTSPOTS.tacoPencil,
        description: 'Tap the pencil icon to customize each taco',
      },
      {
        image: tacoStep2,
        imageRef: TUTORIAL_IMAGE_REFS.tacoStep2,
        highlight: TUTORIAL_HOTSPOTS.tacoUndoChanges,
        description: 'Tap Undo Changes to reset your edits',
      },
      {
        image: tacoStep3,
        imageRef: TUTORIAL_IMAGE_REFS.tacoStep3,
        highlight: TUTORIAL_HOTSPOTS.tacoSameAsTacoOne,
        description: 'Tap Same as Taco One to copy your first pick',
      },
    ],
  },
  {
    id: 'burrito',
    type: 'multiFrame',
    showSkip: true,
    title: 'Burritos, Bowls & Salads',
    badgeEmoji: '🌯',
    bodyLead: 'Now you choose your protein',
    bodyRest: 'On ANY burrito, bowl, or salad. Certain exclusions apply.',
    frames: [
      {
        image: burritoStep1,
        imageRef: TUTORIAL_IMAGE_REFS.burritoStep1,
        highlight: TUTORIAL_HOTSPOTS.burritoProductIntro,
        description: 'Start with any burrito, bowl, or salad',
      },
      {
        image: burritoStep2,
        imageRef: TUTORIAL_IMAGE_REFS.burritoStep2,
        highlight: TUTORIAL_HOTSPOTS.burritoChooseProtein,
        description: 'Pick your protein from the yellow header',
      },
      {
        image: burritoStep3,
        imageRef: TUTORIAL_IMAGE_REFS.burritoStep3,
        highlight: TUTORIAL_HOTSPOTS.burritoCustomizeOptions,
        description: 'Adjust beans and toppings to your taste',
      },
      {
        image: burritoStep4,
        imageRef: TUTORIAL_IMAGE_REFS.burritoStep4,
        highlight: TUTORIAL_HOTSPOTS.burritoSummary,
        description: 'Review your selections in the customize summary',
      },
    ],
  },
  {
    id: 'nameMap',
    type: 'nameMapping',
    showSkip: true,
    title: "Can't find your favorites?",
    bodyLead: null,
  },
];
